export default __webpack_public_path__ + "static/media/bullet.84626abc.svg";